module.exports = __webpack_public_path__ + "img/t3-11.96c66923.svg";